import styled from 'styled-components';
import { themeGet } from '../../foundation/theme/themeGet/get.js';
import { breakpoints } from '../../foundation/breakpoints/values.js';
import { pxToRem } from '../../foundation/spacing/utils.js';
import { H3 } from '../../foundation/Typography/styled.js';

var Content = styled.div.withConfig({
  displayName: "Content",
  componentId: "sc-1lv9h61-0"
})(["display:flex;flex-direction:column;"]);
var Container = styled.header.withConfig({
  displayName: "Container",
  componentId: "sc-1lv9h61-1"
})(["display:flex;flex-direction:column;width:100%;min-width:0;padding:", " 0;background-color:", ";", " ", "{padding:", " 0;", "}"], themeGet('spacing.xl'), themeGet('colors.background.50'), function (props) {
  return props.$withTabs && "\n    padding-bottom: 0;\n\n    " + Content + " {\n      padding-bottom: " + themeGet('spacing.xl') + ";\n\n      " + breakpoints.sm + " {\n        padding-bottom: " + themeGet('spacing.2xl') + ";\n      }\n    }\n    ";
}, breakpoints.sm, themeGet('spacing.2xl'), function (props) {
  return props.$withTabs && "\n      padding-bottom: 0;\n      ";
});
var HeaderActionsContainer = styled.div.withConfig({
  displayName: "HeaderActionsContainer",
  componentId: "sc-1lv9h61-2"
})(["display:flex;flex-direction:column;justify-content:space-between;gap:", ";", "{flex-direction:row;}&:not(:last-child){margin-bottom:", ";}"], themeGet('spacing.md'), breakpoints.sm, themeGet('spacing.md'));
var Header = styled.div.withConfig({
  displayName: "Header",
  componentId: "sc-1lv9h61-3"
})(["display:flex;align-items:center;flex:1 1 auto;gap:", ";min-height:", ";overflow:hidden;"], themeGet('spacing.md'), pxToRem(40));
var Actions = styled.div.withConfig({
  displayName: "Actions",
  componentId: "sc-1lv9h61-4"
})(["display:flex;align-items:center;flex-shrink:0;gap:", ";"], themeGet('spacing.md'));
var StyledTypography = styled(H3).withConfig({
  displayName: "StyledTypography",
  componentId: "sc-1lv9h61-5"
})(["display:-webkit-box;-webkit-line-clamp:1;-webkit-box-orient:vertical;overflow:hidden;text-overflow:ellipsis;", "{-webkit-line-clamp:1;}"], breakpoints.lg);

export { Actions, Container, Content, Header, HeaderActionsContainer, StyledTypography };
